import { z } from "zod";

const metaEnvSchema = z.object({
	VITE_BUILD_ENV: z.enum(["local", "development", "staging", "production"]),

	VITE_RECRUTA_AI_WEB_BASE_URL: z.string().url(),
	VITE_RECRUTA_AI_API_BASE_URL: z.string().url(),

	VITE_ENABLE_MSW: z.union([z.literal("true"), z.literal("false")]),

	VITE_COGNITO_USER_POOL_ID: z.string(),
	VITE_COGNITO_USER_POOL_WEB_CLIENT_ID: z.string(),

	// Viteのデフォルトの環境変数
	BASE_URL: z.string(),
	MODE: z.string(),
	DEV: z.boolean(),
	PROD: z.boolean(),
	SSR: z.boolean(),
});

// vite-env.d.tsの型と一致することを確認する
type Meta = z.infer<typeof metaEnvSchema>;
import.meta.env satisfies Meta;

export const validateEnv = () => {
	const parsedEnv = metaEnvSchema.safeParse(import.meta.env);

	if (!parsedEnv.success) {
		throw new Error("環境変数が正しく設定されていません");
	}
};
